import { useState } from "react";
import { useParams } from "react-router-dom";
import "../tabs-style.css";
import Footer from "../footer/Footer";
import Navbar from "../navbar/Navbar";

/* ================= DATA ================= */

const COMMITTEES_MOM_DATA = {
    "2025-26": {
        committees: {
            "Anti-Ragging Committee": [
                {
                    name: "MoM – Anti-Ragging Committee",
                    link: "https://example.com/2025-26/anti-ragging.pdf",
                },
            ],
            "Grievance Redressal Cell Committee": [],
            "Internal Committee": [],
            "SC/ST Committee": [],
            "IQAC Committee": [],
            "Institution Industry Cell": [],
            "Research & Development Cell": [],
            "Innovation Cell / Club": [],
            "Media Cell": [],
            "Intellectual Property Rights": [],
        },
    },
    "2024-25": { committees: {} },
    "2023-24": {
        committees: {
            "IQAC Committee": [
                {
                    name: "IQAC Meeting Minutes",
                    link: "https://example.com/2023-24/iqac-mom.pdf",
                },
            ],
        },
    },
    "2022-23": { committees: {
            "Anti-Ragging Committee": [
                {
                    name: "MoM – Anti-Ragging Committee",
                    link: "https://example.com/2025-26/anti-ragging.pdf",
                },
            ],
            "Grievance Redressal Cell Committee": [],
            "Internal Committee": [],
            "SC/ST Committee": [],
            "IQAC Committee": [],
            "Institution Industry Cell": [],
            "Research & Development Cell": [],
            "Innovation Cell / Club": [],
            "Media Cell": [],
            "Intellectual Property Rights": [],
        } },
};

const YEARS = ["2025-26", "2024-25", "2023-24", "2022-23"];

const COMMITTEES = [
    "Anti-Ragging Committee",
    "Grievance Redressal Cell Committee",
    "Internal Committee",
    "SC/ST Committee",
    "IQAC Committee",
    "Institution Industry Cell",
    "Research & Development Cell",
    "Innovation Cell / Club",
    "Media Cell",
    "Intellectual Property Rights",
];

/* ================= COMPONENT ================= */

const CommittiesMoM = () => {
    const { year } = useParams();

    /* ✅ DEFINE FIRST */
    const getDefaultCommittee = (yr) => {
        const yearData = COMMITTEES_MOM_DATA[yr]?.committees || {};

        // Prefer committee which has documents
        const withDocs = Object.keys(yearData).find(
            (c) => yearData[c]?.length > 0
        );

        return withDocs || COMMITTEES[0];
    };

    /* ✅ THEN USE */
    const [activeYear, setActiveYear] = useState(year || null);
    const [activeCommittee, setActiveCommittee] = useState(
        year ? getDefaultCommittee(year) : null
    );

    const handleYearClick = (yr) => {
        setActiveYear((prev) => (prev === yr ? null : yr));
        setActiveCommittee(getDefaultCommittee(yr));
        window.history.pushState(null, "", `/about/Committees-MoM/${yr}`);
    };


    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 ps-lg-4">

                            <div className="row">
                                {/* LEFT COLUMN */}
                                <div className="col-xl-3">

                                    {YEARS.map((yr) => (
                                        <div key={yr}>
                                            <button
                                                className="btn btn-danger py-2 w-100 border-0 mb-2 d-flex align-items-center justify-content-between"
                                                onClick={() => handleYearClick(yr)}
                                            >
                                                Committees MoM {yr}
                                                <i
                                                    className={`fa ${activeYear === yr
                                                            ? "fa-chevron-up"
                                                            : "fa-chevron-down"
                                                        }`}
                                                ></i>
                                            </button>

                                            {activeYear === yr && (
                                                <ul className="react-tabs__tab-list" style={{ listStyle: "none" }}>
                                                    {COMMITTEES.map((committee, idx) => (
                                                        <li
                                                            key={idx}
                                                            className={`react-tabs__tab p-2 ${activeCommittee === committee
                                                                    ? "react-tabs__tab--selected"
                                                                    : ""
                                                                }`}
                                                            onClick={() =>
                                                                setActiveCommittee(committee)
                                                            }
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {committee}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                {/* RIGHT COLUMN */}
                                <div className="col-xl-9">
                                    {activeYear && activeCommittee && (
                                        <>
                                            <h4>
                                                {activeCommittee} – {activeYear}
                                            </h4>
                                            <span>&nbsp;</span>

                                            <div className="detgails-right-content mt-4">
                                                <div className="related-download bg-gray">
                                                    <ul>
                                                        {(COMMITTEES_MOM_DATA[activeYear]
                                                            ?.committees?.[activeCommittee] || []
                                                        ).length > 0 ? (
                                                            COMMITTEES_MOM_DATA[activeYear]
                                                                .committees[activeCommittee].map(
                                                                    (doc, i) => (
                                                                        <li key={i}>
                                                                            <a
                                                                                href={doc.link}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                <i className="fa-solid fa-file-pdf"></i>{" "}
                                                                                {doc.name}
                                                                            </a>
                                                                        </li>
                                                                    )
                                                                )
                                                        ) : (
                                                            <li>No documents available</li>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default CommittiesMoM;
